// 供应商选择
import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, nullDate, getListIds } from '../../../public/utility'
class SelectSupplierDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.doGetSelectSupplier()
    }

    doGetSelectSupplier = (searchString = '') => {
        const { ids } = this.props
        Tyan.doPostEvent('GetSelectSupplier', {
            data: {
                search: searchString,
                ids
            },
            onEnd: ({ errorMessage, initValues供应商 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ initValues基本信息: {}, changedValues基本信息: {}, initValues供应商 })
                }
            }
        })
    }

    handlerSave = () => {
        const { id, onClose, onSave } = this.props
        const { changedValues基本信息 } = this.state
        const { list } = getListFromValues('供应商', '', null, changedValues基本信息)
        if (list.length > 1) {
            Tyan.pubForm.showError('只能选一条记录')
            return
        }
        Tyan.doPostEvent('CreateSupplierEvaluate', {
            data: {
                id, changedValues基本信息
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { initValues供应商 } = this.state
        return [
            {
                _checkgrid: '', name: '供应商', rowNumbers: false, minRows: 15, margin: "5px 10px 5px 10px", minWidth: '90%',
                itemsValues: initValues供应商, onSearch: this.doGetSelectSupplier,
                columns: [
                    { _text: '供应商编号', minWidth: 150, flex: 2 },
                    { _text: '供应商名称', minWidth: 150, flex: 2 },
                ],
            }]
    }

    render() {
        const { showMessage: Message, showBody: Body, bReadOnly, } = this.props
        const { errorMessage, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1000"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(SelectSupplierDiv)